import { useQuery } from '@tanstack/react-query'
import { Modal } from 'antd'
import React from 'react'
import { getMessage } from '../../services/api'
import { ModalMessageContent, ModalMessageContentItem } from './styled'

type ModalMessageType = {
    isOpen: boolean,
    id: number,
    onClose: () => void
}

const ModalMessage = ({isOpen, id, onClose}: ModalMessageType) => {

    const { data, isFetched } = useQuery(['message', {id: id}], () => getMessage(id));

    return (
        <Modal title="Message" open={isOpen} onCancel={() => onClose()}>
            {isFetched && (
                <ModalMessageContent>
                    <ModalMessageContentItem>
                        <span>Poruka:</span>
                        <p>{data.data.message}</p>
                    </ModalMessageContentItem>
                    <ModalMessageContentItem>
                        <span>Ime i prezime:</span>
                        <p>{data.data.name}</p>
                    </ModalMessageContentItem>
                    <ModalMessageContentItem>
                        <span>e-Mail:</span>
                        <p>{data.data.email}</p>
                    </ModalMessageContentItem>
                    <ModalMessageContentItem>
                        <span>Telefon:</span>
                        <p>{data.data.phone}</p>
                    </ModalMessageContentItem>
                    <ModalMessageContentItem>
                        <span>Usluga:</span>
                        <p>{data.data.service}</p>
                    </ModalMessageContentItem>
                </ModalMessageContent>
            )}
        </Modal>
    )
}

export default ModalMessage